export const arrayValues = (n: number, type: 'values' | 'keys' = 'values') => {
  return Array.from(Array(n)[type]())
}
